var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2H2V22H22V2ZM20 4H4V20H20V4Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.27273C9.89364 8.27273 8.18182 9.98455 8.18182 12.0909H10.0909L7.54545 14.6364L5 12.0909H6.90909C6.90909 9.27818 9.18727 7 12 7C12.9991 7 13.9282 7.29273 14.7109 7.78909L13.7818 8.71818C13.2536 8.43182 12.6427 8.27273 12 8.27273ZM13.9091 12.0909L16.4545 9.54545L19 12.0909H17.0909C17.0909 14.9036 14.8127 17.1818 12 17.1818C11.0009 17.1818 10.0718 16.8891 9.28909 16.3927L10.2182 15.4636C10.7464 15.75 11.3573 15.9091 12 15.9091C14.1064 15.9091 15.8182 14.1973 15.8182 12.0909H13.9091Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewal);
export default __webpack_public_path__ + "static/media/renewal.f821f3f08a2ef8a387aea8c6ec5e6d38.svg";
export { ForwardRef as ReactComponent };